<template>
  <div class="resiliency-quiz-results">
    <div class="">

      <div class="row no-margin-x">

        <div class="col-md-12">
          <div class="row no-margin-x">
            <div class="col-md-12 no-padding-x">
              <h1 class="d2lWhite_txt">{{ $route.name }}<span v-if="$route.params.eventId"> – {{ $route.params.eventId | eventDisplayName }}</span></h1>
              <div class="row no-margin-x">
                <div class="col-md-8 no-padding-x">
                  <leaderboard @leader-determined="setCurrentLeaders"></leaderboard>
                </div>
                <div class="col-md-3 d2lWhite_bg leaderboard-info padding-left-3 padding-right-3 hidden-xs hidden-sm">
                  <div class="qrcode-wrap hidden-xs hidden-sm height-100 flex padding-top-4 padding-bottom-4">

                    <!-- <div class="graph-legend">
                      <div v-for="(type, index) in typeColors" :key="index">
                        <span class="graph-legend-color"></span><span class="graph-legend-title">{{ type }}</span>
                      </div>
                    </div> -->

                    <div class="current-leader text-center">
                      <h2 class="h3">Current Leader</h2>
                      <div v-if="currentLeaders.length" class="margin-bottom-3">
                        <div class="margin-top-2 margin-bottom">
                          <img :src="currentLeaders[0].image" alt="">
                        </div>
                        <span>{{ currentLeaders.map(({ type }) => type).join(', ') }}</span>
                      </div>
                    </div>

                    <div class="text-center">
                      <div ref="qrcode" v-html="qrCodeMarkup"></div>
                      <h2 class="h3 margin-bottom-2">Scan to take the Quiz</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
import leaderboard from '../components/leaderboard.vue';
import globalMixin from '../mixins/global';
import qrMixin from '../mixins/qr';
import sharedNavigationLogicMixin from '../mixins/quiz-navigation';

export default {
  components: {
    leaderboard
  },

  data: () => ({
    currentLeaders: []
  }),
  
  mixins: [
    globalMixin,
    sharedNavigationLogicMixin,
    qrMixin
  ],

  computed: {
    leaderboardTitle() {
      let title = 'Leaderboard';
      
      if (this.isSingleEvent()) {
        title = `${this.$route.params.eventId} ${title}`;
      }
      
      return title;
    }
  },

  methods: {
    setCurrentLeaders(data = []) {
      if ( ! data.length ) return;
      
      const currentLeaders = data.map(({ type }) => ({
        type,
        image: require('../assets/learner-quiz-' + type +'.png')
      }));
      
      this.currentLeaders = currentLeaders;
    }
  },

  mounted() {
    this.generateQR({
      container: 'svg-viewbox'
    });
  }
}
</script>

<style>
  body {
    overflow-x: initial;
  }
  .container {
    height: initial;
    box-shadow: initial;
  }
</style>
